export default "__VITE_ASSET__DitehQVK__"